import { EstimatedValue } from './EstimatedValue'
import { EstimatedValuePreview } from './EstimatedValuePreview'
import { compose, withContext } from 'recompose'
import PropTypes from 'prop-types'

// can remove this file once all downstream children are not using recompose "getContext" (replace with props)
const provideContextDashboard = withContext(
  { withCurrentHomeData: PropTypes.bool, locked: PropTypes.bool },
  () => ({
    withCurrentHomeData: true,
    locked: false,
  })
)

const provideContextPreview = withContext(
  { withCurrentHomeData: PropTypes.bool, locked: PropTypes.bool },
  () => ({
    withCurrentHomeData: false,
    locked: true,
  })
)

const EstimatedValueContainerDashboard = compose(provideContextDashboard)
const EstimatedValueContainerPreview = compose(provideContextPreview)

const EstimatedValueWithContext =
  EstimatedValueContainerDashboard(EstimatedValue)
const EstimatedValuePreviewWithContext = EstimatedValueContainerPreview(
  EstimatedValuePreview
)

export { EstimatedValueWithContext, EstimatedValuePreviewWithContext }
